var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLayers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    fill: "#ffffff",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 18.004a.747.747 0 0 1-.355-.09l-9.75-5.25.71-1.32L12 16.402l9.395-5.058.71 1.32-9.75 5.25a.747.747 0 0 1-.355.09Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 22.504a.747.747 0 0 1-.355-.09l-9.75-5.25.71-1.32L12 20.902l9.395-5.058.71 1.32-9.75 5.25a.747.747 0 0 1-.355.09Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.5a.75.75 0 0 1-.356-.09l-9.75-5.25a.75.75 0 0 1 0-1.32l9.75-5.25a.748.748 0 0 1 .711 0l9.75 5.25a.75.75 0 0 1 0 1.32l-9.75 5.25a.75.75 0 0 1-.355.09Zm-8.168-6L12 11.9l8.168-4.4L12 3.102 3.832 7.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayers);
export default __webpack_public_path__ + "static/media/layers.e52a5a3f419dbe901c00c5149e97aa6d.svg";
export { ForwardRef as ReactComponent };